import { useState, useEffect, useCallback } from "react";
import api from "../api";

const ORANGE = "#EE6A1A";
const VERDE = "#1D9E75";
const AZUL = "#579bfc";
const VERM = "#e2445c";

const dois = (n) => String(n).padStart(2, "0");
const DIAS = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];
const TURNOS = [["manha", "Manhã"], ["tarde", "Tarde"], ["noite", "Noite"]];

const fmtData = (d) => { const x = new Date(d); return dois(x.getDate()) + "/" + dois(x.getMonth() + 1); };
const fmtHora = (d) => { const x = new Date(d); return dois(x.getHours()) + ":" + dois(x.getMinutes()); };
const fmtDiaSemana = (d) => DIAS[new Date(d).getDay()];
const reais = (v) => "R$ " + Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const iso = (d) => d.getFullYear() + "-" + dois(d.getMonth() + 1) + "-" + dois(d.getDate());

const paraWhats = (tel) => {
  const n = String(tel || "").replace(/\D/g, "");
  if (!n) return "";
  return n.length <= 11 ? "55" + n : n;
};

const nomeEmpresa = () => {
  try {
    const c = JSON.parse(localStorage.getItem("crm_config") || "{}");
    if (c && c.nome) return c.nome;
    const e = JSON.parse(localStorage.getItem("crm_empresa") || "{}");
    return (e && e.nome) || "nossa clínica";
  } catch (x) { return "nossa clínica"; }
};

const msgVaga = (p, v) =>
  "Olá " + String(p.pacienteNome || "").split(" ")[0] + "! Aqui é da " + nomeEmpresa() +
  ". Você pediu para ser avisada quando abrisse horário" +
  (p.procedimento ? " de " + p.procedimento : "") + ": abriu uma vaga " +
  fmtDiaSemana(v.inicio) + " dia " + fmtData(v.inicio) + " às " + fmtHora(v.inicio) +
  (v.procedimento ? " (" + v.procedimento + ")" : "") +
  ". Quer pegar? Responde aqui que eu já reservo para você.";

const resumoPreferencias = (p) => {
  const partes = [];
  partes.push(p.diasSemana && p.diasSemana.length ? p.diasSemana.map((d) => DIAS[d]).join(", ") : "qualquer dia");
  partes.push(p.turnos && p.turnos.length ? p.turnos.map((t) => (TURNOS.find((x) => x[0] === t) || [])[1]).join(", ") : "qualquer turno");
  if (p.validade) partes.push("até " + fmtData(p.validade));
  return partes.join(" · ");
};

// ─────────────────────────────── cadastro na fila

function ModalEspera({ item, catalogo, onFechar, onSalvo }) {
  const isNew = !item._id;
  const [f, setF] = useState({
    pacienteNome: item.pacienteNome || "",
    telefone: item.telefone || "",
    procedimento: item.procedimento || "",
    diasSemana: item.diasSemana || [],
    turnos: item.turnos || [],
    aPartirDe: item.aPartirDe ? iso(new Date(item.aPartirDe)) : "",
    validade: item.validade ? iso(new Date(item.validade)) : "",
    urgente: !!item.urgente,
    obs: item.obs || "",
  });
  const [erro, setErro] = useState("");
  const [salvando, setSalvando] = useState(false);
  const set = (k, v) => setF((x) => ({ ...x, [k]: v }));
  const alterna = (campo, v) => setF((x) => {
    const atual = x[campo] || [];
    return { ...x, [campo]: atual.indexOf(v) === -1 ? [...atual, v] : atual.filter((y) => y !== v) };
  });

  const inp = { width: "100%", boxSizing: "border-box", padding: "9px 11px", borderRadius: 8, border: "1px solid var(--border-color)", background: "var(--input-bg)", color: "var(--text-primary)", fontSize: 13, fontFamily: "'Inter',sans-serif", outline: "none" };
  const lbl = { fontSize: 11, fontWeight: 600, color: "var(--text-secondary)", marginBottom: 5, display: "block", textTransform: "uppercase", letterSpacing: ".04em" };
  const chip = (ativo) => ({ padding: "7px 13px", borderRadius: 8, border: ativo ? 0 : "1px solid var(--border-color)", background: ativo ? ORANGE : "transparent", color: ativo ? "#fff" : "var(--text-secondary)", fontSize: 12.5, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" });

  const salvar = async () => {
    if (!f.pacienteNome.trim()) return setErro("Informe o paciente.");
    setErro(""); setSalvando(true);
    try {
      const corpo = {
        ...f,
        aPartirDe: f.aPartirDe || null,
        validade: f.validade || null,
      };
      const { data } = isNew ? await api.post("/espera", corpo) : await api.put(`/espera/${item._id}`, corpo);
      onSalvo(data);
    } catch (err) {
      setErro((err.response && err.response.data && err.response.data.message) || "Não foi possível salvar.");
    } finally { setSalvando(false); }
  };

  return (
    <div onClick={onFechar} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.45)", zIndex: 1000, display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "40px 16px", overflowY: "auto" }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: "var(--card-bg)", borderRadius: 14, padding: 24, width: "100%", maxWidth: 520, boxShadow: "0 20px 60px rgba(0,0,0,.25)" }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: "var(--text-primary)", marginBottom: 4 }}>{isNew ? "Adicionar à lista de espera" : "Editar"}</div>
        <div style={{ fontSize: 12.5, color: "var(--text-muted)", marginBottom: 18 }}>Quando abrir uma vaga que combine, essa pessoa aparece para ser chamada.</div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 160px", gap: 12, marginBottom: 14 }}>
          <div><label style={lbl}>Paciente</label><input autoFocus value={f.pacienteNome} onChange={(e) => set("pacienteNome", e.target.value)} style={inp} /></div>
          <div><label style={lbl}>Telefone</label><input value={f.telefone} onChange={(e) => set("telefone", e.target.value)} placeholder="(00) 00000-0000" style={inp} /></div>
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={lbl}>Procedimento que ela quer</label>
          <input list="espera-procedimentos" value={f.procedimento} onChange={(e) => set("procedimento", e.target.value)} placeholder="Deixe vazio para qualquer procedimento" style={inp} />
          <datalist id="espera-procedimentos">{catalogo.map((c) => <option key={c._id} value={c.nome} />)}</datalist>
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={lbl}>Dias que ela pode</label>
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
            {DIAS.map((d, i) => <button key={d} onClick={() => alterna("diasSemana", i)} style={chip(f.diasSemana.indexOf(i) !== -1)}>{d}</button>)}
          </div>
          <div style={{ fontSize: 11.5, color: "var(--text-muted)", marginTop: 6 }}>Nenhum marcado = qualquer dia serve.</div>
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={lbl}>Turnos</label>
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
            {TURNOS.map(([id, rot]) => <button key={id} onClick={() => alterna("turnos", id)} style={chip(f.turnos.indexOf(id) !== -1)}>{rot}</button>)}
          </div>
          <div style={{ fontSize: 11.5, color: "var(--text-muted)", marginTop: 6 }}>Manhã até 12h · Tarde até 18h · Noite depois disso.</div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 14 }}>
          <div><label style={lbl}>Só a partir de</label><input type="date" value={f.aPartirDe} onChange={(e) => set("aPartirDe", e.target.value)} style={inp} /></div>
          <div><label style={lbl}>Sai da lista em</label><input type="date" value={f.validade} onChange={(e) => set("validade", e.target.value)} style={inp} /></div>
        </div>

        <label style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: 14, cursor: "pointer", fontSize: 13, color: "var(--text-primary)" }}>
          <input type="checkbox" checked={f.urgente} onChange={(e) => set("urgente", e.target.checked)} />
          Chamar essa antes das outras
        </label>

        <div style={{ marginBottom: 16 }}>
          <label style={lbl}>Observação</label>
          <textarea value={f.obs} onChange={(e) => set("obs", e.target.value)} style={{ ...inp, minHeight: 56, resize: "vertical" }} placeholder="Ex: só consegue vir depois das 17h" />
        </div>

        {erro && <div style={{ fontSize: 13, color: VERM, marginBottom: 12 }}>{erro}</div>}

        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button onClick={onFechar} style={{ padding: "10px 18px", borderRadius: 9, border: "1px solid var(--border-color)", background: "transparent", color: "var(--text-secondary)", fontWeight: 600, fontSize: 13, cursor: "pointer", fontFamily: "inherit" }}>Cancelar</button>
          <button onClick={salvar} disabled={salvando} style={{ padding: "10px 20px", borderRadius: 9, border: 0, background: ORANGE, color: "#fff", fontWeight: 700, fontSize: 13, cursor: "pointer", fontFamily: "inherit", opacity: salvando ? .6 : 1 }}>{salvando ? "Salvando…" : "Salvar"}</button>
        </div>
      </div>
    </div>
  );
}

// ─────────────────────────────── chamar a fila para uma vaga

function ModalCandidatos({ vagaId, onFechar, onMudou }) {
  const [d, setD] = useState(null);
  const [erro, setErro] = useState("");
  const [chamados, setChamados] = useState({});

  useEffect(() => {
    api.get(`/espera/vagas/${vagaId}/candidatos`)
      .then(({ data }) => setD(data))
      .catch((e) => setErro((e.response && e.response.data && e.response.data.message) || "Não foi possível carregar."));
  }, [vagaId]);

  const chamar = async (p) => {
    const fone = paraWhats(p.telefone);
    if (!fone) return window.alert("Essa pessoa não tem telefone cadastrado.");
    window.open("https://wa.me/" + fone + "?text=" + encodeURIComponent(msgVaga(p, d.vaga)), "_blank");
    setChamados((x) => ({ ...x, [p._id]: true }));
    try { await api.post(`/espera/${p._id}/avisado`); } catch (e) {}
    onMudou();
  };

  const encaixar = async (p) => {
    if (!window.confirm(`Marcar ${p.pacienteNome} como encaixada nessa vaga? Ela sai da lista de espera e a vaga fecha.`)) return;
    try {
      await api.patch(`/espera/${p._id}/status`, { status: "encaixado" });
      await api.post(`/espera/vagas/${vagaId}/fechar`);
      onMudou(); onFechar();
    } catch (e) { window.alert("Não foi possível registrar."); }
  };

  const btn = (primario) => ({ padding: "7px 14px", borderRadius: 8, border: primario ? 0 : "1px solid var(--border-color)", background: primario ? VERDE : "transparent", color: primario ? "#fff" : "var(--text-secondary)", fontWeight: 700, fontSize: 12, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" });

  return (
    <div onClick={onFechar} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.45)", zIndex: 1000, display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "40px 16px", overflowY: "auto" }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: "var(--card-bg)", borderRadius: 14, padding: 24, width: "100%", maxWidth: 560, boxShadow: "0 20px 60px rgba(0,0,0,.25)" }}>
        {erro && <div style={{ fontSize: 13, color: VERM }}>{erro}</div>}
        {!d && !erro && <div style={{ fontSize: 13, color: "var(--text-muted)" }}>Carregando…</div>}
        {d && (
          <>
            <div style={{ fontSize: 16, fontWeight: 700, color: "var(--text-primary)" }}>
              Vaga {fmtDiaSemana(d.vaga.inicio)} {fmtData(d.vaga.inicio)} às {fmtHora(d.vaga.inicio)}
            </div>
            <div style={{ fontSize: 12.5, color: "var(--text-muted)", margin: "4px 0 18px" }}>
              {d.vaga.procedimento || "Sem procedimento definido"}
              {d.vaga.profissionalNome ? " · " + d.vaga.profissionalNome : ""}
              {d.vaga.valor ? " · " + reais(d.vaga.valor) : ""}
            </div>

            {!d.candidatos.length && (
              <div style={{ fontSize: 13, color: "var(--text-muted)", lineHeight: 1.5 }}>
                Ninguém da lista de espera combina com esse horário. Se quiser, cadastre alguém com preferência para esse dia e turno.
              </div>
            )}

            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {d.candidatos.map((p, i) => (
                <div key={p._id} style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 14px", borderRadius: 10, background: "var(--hover-bg)" }}>
                  <div style={{ fontSize: 12, fontWeight: 800, color: "var(--text-muted)", minWidth: 20 }}>{i + 1}º</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 13.5, fontWeight: 700, color: "var(--text-primary)" }}>
                      {p.pacienteNome}
                      {p.urgente && <span style={{ fontSize: 10.5, fontWeight: 700, color: ORANGE, background: ORANGE + "1a", borderRadius: 5, padding: "2px 6px", marginLeft: 8 }}>prioridade</span>}
                    </div>
                    <div style={{ fontSize: 12, color: "var(--text-secondary)", marginTop: 2 }}>
                      {p.procedimento || "qualquer procedimento"} · {p.telefone || "sem telefone"}
                      {p.vezesAvisado ? " · já chamada " + p.vezesAvisado + "x" : ""}
                    </div>
                  </div>
                  <button onClick={() => chamar(p)} style={btn(false)}>{chamados[p._id] ? "Chamar de novo" : "Chamar"}</button>
                  <button onClick={() => encaixar(p)} style={btn(true)}>Encaixou</button>
                </div>
              ))}
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 18 }}>
              <button onClick={onFechar} style={{ padding: "10px 18px", borderRadius: 9, border: "1px solid var(--border-color)", background: "transparent", color: "var(--text-secondary)", fontWeight: 600, fontSize: 13, cursor: "pointer", fontFamily: "inherit" }}>Fechar</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

// ─────────────────────────────── tela

export default function Espera() {
  const [vagas, setVagas] = useState([]);
  const [fila, setFila] = useState([]);
  const [catalogo, setCatalogo] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState("");
  const [modal, setModal] = useState(null);
  const [vagaAberta, setVagaAberta] = useState(null);

  const carregar = useCallback(() => {
    setCarregando(true);
    Promise.all([api.get("/espera/vagas"), api.get("/espera")])
      .then(([v, f]) => { setVagas(v.data.vagas || []); setFila(f.data.lista || []); setErro(""); })
      .catch((e) => setErro((e.response && e.response.data && e.response.data.message) || "Não foi possível carregar."))
      .finally(() => setCarregando(false));
  }, []);
  useEffect(() => { carregar(); }, [carregar]);
  useEffect(() => { api.get("/catalogo").then(({ data }) => setCatalogo(Array.isArray(data) ? data : [])).catch(() => {}); }, []);

  const fecharVaga = async (v) => {
    if (!window.confirm("Tirar essa vaga da lista? Use quando alguém já pegou o horário ou quando não vale mais oferecer.")) return;
    try { await api.post(`/espera/vagas/${v._id}/fechar`); carregar(); }
    catch (e) { window.alert("Não foi possível."); }
  };

  const mudarStatus = async (p, status) => {
    try { await api.patch(`/espera/${p._id}/status`, { status }); carregar(); }
    catch (e) { window.alert("Não foi possível."); }
  };

  const excluir = async (p) => {
    if (!window.confirm(`Remover ${p.pacienteNome} da lista de espera?`)) return;
    try { await api.delete(`/espera/${p._id}`); carregar(); }
    catch (e) { window.alert("Não foi possível excluir."); }
  };

  const card = { background: "var(--card-bg)", border: "1px solid var(--border-color)", borderRadius: 14, padding: 20, marginBottom: 16 };
  const btn = (primario) => ({ padding: "9px 16px", borderRadius: 9, border: primario ? 0 : "1px solid var(--border-color)", background: primario ? ORANGE : "transparent", color: primario ? "#fff" : "var(--text-secondary)", fontWeight: 700, fontSize: 12.5, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" });
  const th = { textAlign: "left", fontSize: 11, fontWeight: 700, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: ".04em", padding: "0 10px 9px" };
  const td = { fontSize: 13, color: "var(--text-primary)", padding: "11px 10px", borderTop: "1px solid var(--border-color)" };

  return (
    <div style={{ padding: 24, fontFamily: "'Inter',-apple-system,sans-serif", background: "var(--page-bg)", minHeight: "100vh" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 12, marginBottom: 18 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: "var(--text-primary)" }}>Lista de espera</h1>
          <p style={{ margin: "4px 0 0", fontSize: 13, color: "var(--text-muted)" }}>Quando um horário vaga, quem estava esperando é chamado na hora.</p>
        </div>
        <button onClick={() => setModal({})} style={btn(true)}>+ Adicionar à lista</button>
      </div>

      {erro && <div style={{ ...card, color: VERM, fontSize: 13 }}>{erro}</div>}
      {carregando && !vagas.length && !fila.length && <div style={{ fontSize: 13, color: "var(--text-muted)" }}>Carregando…</div>}

      <div style={card}>
        <div style={{ fontSize: 14, fontWeight: 700, color: "var(--text-primary)" }}>Vagas abertas</div>
        <div style={{ fontSize: 12.5, color: "var(--text-muted)", margin: "3px 0 14px" }}>
          Horários que ficaram livres porque a paciente avisou que não vem. Chame alguém da fila antes que o dia chegue.
        </div>

        {!vagas.length && (
          <div style={{ fontSize: 13, color: "var(--text-muted)", lineHeight: 1.5 }}>
            Nenhuma vaga aberta agora. Quando alguém desmarcar pela agenda ou pelo link do WhatsApp, o horário aparece aqui.
          </div>
        )}

        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {vagas.map((v) => (
            <div key={v._id} style={{ display: "flex", alignItems: "center", gap: 14, padding: "14px 16px", borderRadius: 11, background: "var(--hover-bg)", flexWrap: "wrap" }}>
              <div style={{ minWidth: 92 }}>
                <div style={{ fontSize: 15, fontWeight: 800, color: "var(--text-primary)" }}>{fmtData(v.inicio)}</div>
                <div style={{ fontSize: 12, color: "var(--text-secondary)" }}>{fmtDiaSemana(v.inicio)} · {fmtHora(v.inicio)}</div>
              </div>
              <div style={{ flex: 1, minWidth: 160 }}>
                <div style={{ fontSize: 13.5, color: "var(--text-primary)", fontWeight: 600 }}>{v.procedimento || "Sem procedimento"}</div>
                <div style={{ fontSize: 12, color: "var(--text-secondary)", marginTop: 2 }}>
                  {v.profissionalNome || "sem profissional"}
                  {v.valor ? " · " + reais(v.valor) : ""}
                  {v.liberadaPeloPaciente ? " · liberado pela paciente" : " · desmarcado na recepção"}
                </div>
              </div>
              <span style={{ fontSize: 12, fontWeight: 700, color: v.candidatos ? VERDE : "var(--text-muted)", background: (v.candidatos ? VERDE : "#98A2B3") + "18", borderRadius: 7, padding: "5px 10px", whiteSpace: "nowrap" }}>
                {v.candidatos ? v.candidatos + (v.candidatos === 1 ? " pessoa serve" : " pessoas servem") : "ninguém na fila"}
              </span>
              <button onClick={() => setVagaAberta(v._id)} style={btn(!!v.candidatos)}>Ver quem chamar</button>
              <button onClick={() => fecharVaga(v)} style={btn(false)}>Tirar</button>
            </div>
          ))}
        </div>
      </div>

      <div style={card}>
        <div style={{ fontSize: 14, fontWeight: 700, color: "var(--text-primary)" }}>Quem está esperando ({fila.length})</div>
        <div style={{ fontSize: 12.5, color: "var(--text-muted)", margin: "3px 0 14px" }}>
          Cadastre aqui toda paciente que quis um horário e não tinha vaga. É esse cadastro que transforma desmarcação em faturamento.
        </div>

        {!fila.length && <div style={{ fontSize: 13, color: "var(--text-muted)" }}>Ninguém na lista ainda.</div>}

        {fila.length > 0 && (
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead><tr>
                <th style={th}>Paciente</th><th style={th}>Procedimento</th><th style={th}>Quando pode</th>
                <th style={th}>Telefone</th><th style={th}>Chamada</th><th style={th}></th>
              </tr></thead>
              <tbody>
                {fila.map((p) => (
                  <tr key={p._id}>
                    <td style={{ ...td, fontWeight: 600 }}>
                      {p.pacienteNome}
                      {p.urgente && <span style={{ fontSize: 10.5, fontWeight: 700, color: ORANGE, background: ORANGE + "1a", borderRadius: 5, padding: "2px 6px", marginLeft: 8 }}>prioridade</span>}
                      {p.obs && <div style={{ fontSize: 11.5, color: "var(--text-muted)", fontWeight: 400, marginTop: 2 }}>{p.obs}</div>}
                    </td>
                    <td style={{ ...td, color: "var(--text-secondary)" }}>{p.procedimento || "qualquer um"}</td>
                    <td style={{ ...td, color: "var(--text-secondary)", fontSize: 12.5 }}>{resumoPreferencias(p)}</td>
                    <td style={{ ...td, color: "var(--text-secondary)", whiteSpace: "nowrap" }}>{p.telefone || "—"}</td>
                    <td style={{ ...td, color: "var(--text-secondary)", whiteSpace: "nowrap", fontSize: 12.5 }}>
                      {p.vezesAvisado ? p.vezesAvisado + "x · " + fmtData(p.avisadoEm) : "nunca"}
                    </td>
                    <td style={{ ...td, textAlign: "right", whiteSpace: "nowrap" }}>
                      <button onClick={() => setModal(p)} style={{ ...btn(false), padding: "6px 12px", fontSize: 12, marginRight: 6 }}>Editar</button>
                      <button onClick={() => mudarStatus(p, "desistiu")} style={{ ...btn(false), padding: "6px 12px", fontSize: 12, marginRight: 6 }}>Desistiu</button>
                      <button onClick={() => excluir(p)} style={{ ...btn(false), padding: "6px 12px", fontSize: 12, color: VERM, borderColor: VERM + "55" }}>Remover</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div style={{ fontSize: 12.5, color: "var(--text-muted)", lineHeight: 1.6, paddingBottom: 20 }}>
        Como funciona: na tela de Agenda, ao mandar a confirmação do dia seguinte, a paciente recebe um link.
        Se ela clicar em “não vou conseguir ir”, o horário vira uma vaga aqui automaticamente — e quem estava esperando aparece para ser chamado.
      </div>

      {modal && <ModalEspera item={modal} catalogo={catalogo} onFechar={() => setModal(null)} onSalvo={() => { setModal(null); carregar(); }} />}
      {vagaAberta && <ModalCandidatos vagaId={vagaAberta} onFechar={() => setVagaAberta(null)} onMudou={carregar} />}
      <span style={{ display: "none" }}>{AZUL}</span>
    </div>
  );
}
